var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.token && _vm.user.type === 'internal')?_c('navbarinternal'):_vm._e(),(_vm.token && _vm.user.type === 'company')?_c('navbar'):_vm._e(),_c('v-main',{staticStyle:{"background":"#F9F9F9"},attrs:{"light":""}},[_c('router-view',{staticStyle:{"padding-left":"2px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }